// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.label-selection-modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9998;
}

.label-selection-modal {
  background: white;
  border-radius: 8px;
  padding: 24px;
  width: 90%;
  max-width: 500px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
}

.label-selection-modal-title {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 16px;
  text-align: center;
  color: #333;
}

.label-selection-options {
  margin-bottom: 20px;
}

.label-selection-option {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-weight: 500;
  color: #333;
  margin-bottom: 8px;
}
.label-selection-option input {
  width: 16px;
  height: 16px;
  accent-color: var(--primary-color, #004A9A);
  margin-right: 8px;
}

.label-selection-desc {
  font-size: 14px;
  color: #666;
  margin-left: 24px;
  line-height: 1.4;
  margin-top: 8px;
  margin-bottom: 12px;
}

.existing-labels-section {
  margin-top: 20px;
  margin-bottom: 20px;
  padding: 15px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background-color: #f8f9fa;
  position: relative;
}

.search-container {
  margin-bottom: 15px;
}

.dropdown-container {
  margin-bottom: 15px;
}

.dropdown-label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #333;
  font-size: 14px;
}

.label-dropdown {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  background-color: white;
  cursor: pointer;
}
.label-dropdown:focus {
  outline: none;
  border-color: var(--primary-color, #004A9A);
  box-shadow: 0 0 0 2px rgba(0, 74, 154, 0.2);
}
.label-dropdown:disabled {
  background-color: #f5f5f5;
  cursor: not-allowed;
  opacity: 0.6;
}
.label-dropdown option {
  padding: 8px;
}

.label-search-input {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
}
.label-search-input:focus {
  outline: none;
  border-color: var(--primary-color, #004A9A);
  box-shadow: 0 0 0 2px rgba(0, 74, 154, 0.2);
}

.loading-container {
  text-align: center;
  padding: 20px;
  color: #666;
  font-style: italic;
}

.labels-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.label-item {
  display: flex;
  align-items: flex-start;
  padding: 10px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  background: white;
  cursor: pointer;
  transition: all 0.2s ease;
}
.label-item:hover {
  border-color: var(--primary-color, #004A9A);
  background-color: #f8f9ff;
}
.label-item input[type=checkbox] {
  margin-right: 12px;
  margin-top: 2px;
  width: 16px;
  height: 16px;
  accent-color: var(--primary-color, #004A9A);
}

.label-info {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.label-name-color {
  display: flex;
  align-items: center;
  gap: 8px;
}

.label-name {
  font-weight: 500;
  color: #333;
  font-size: 14px;
}

.label-color-indicator {
  width: 16px;
  height: 16px;
  border-radius: 3px;
  border: 1px solid rgba(0, 0, 0, 0.1);
}

.label-description {
  font-size: 12px;
  color: #666;
  line-height: 1.3;
}

.label-priority {
  font-size: 11px;
  color: #888;
  font-weight: 500;
}

.no-labels-message {
  text-align: center;
  color: #666;
  font-style: italic;
  padding: 20px;
}

.selected-count {
  margin-top: 15px;
  padding: 10px 15px;
  background: linear-gradient(135deg, var(--primary-color, #004A9A) 0%, #0066cc 100%);
  color: white;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  box-shadow: 0 2px 4px rgba(0, 74, 154, 0.2);
}

.selected-labels-container {
  margin-top: 20px;
  padding: 15px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  background-color: #f8fafc;
}

.selected-labels-title {
  margin: 0 0 12px 0;
  font-size: 14px;
  font-weight: 600;
  color: #374151;
}

.selected-labels-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.selected-label-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  background-color: white;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  transition: all 0.2s ease;
}
.selected-label-item:hover {
  border-color: #9ca3af;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.selected-label-item .label-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1 1;
}
.selected-label-item .label-info .label-name {
  font-weight: 500;
  color: #111827;
  font-size: 14px;
  line-height: 1.4;
}
.selected-label-item .label-info .label-description {
  font-size: 12px;
  color: #6b7280;
  line-height: 1.3;
  font-style: italic;
}

.remove-label-btn {
  background: grey;
  color: white;
  border: none;
  border-radius: 50%;
  width: 22px;
  height: 22px;
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  flex-shrink: 0;
}
.remove-label-btn:hover {
  transform: scale(1.05);
}
.remove-label-btn:active {
  transform: scale(0.95);
}

/* Searchable Dropdown Styles */
.searchable-dropdown-container {
  margin-bottom: 20px;
  position: relative;
}
.searchable-dropdown-container .dropdown-label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #333;
}
.searchable-dropdown-container .searchable-dropdown {
  position: relative;
  /* Add smooth scrolling */
}
.searchable-dropdown-container .searchable-dropdown * {
  scroll-behavior: smooth;
}
.searchable-dropdown-container .searchable-dropdown .search-input-container {
  display: flex;
  border: 2px solid #ddd;
  border-radius: 6px;
  overflow: hidden;
  background: white;
}
.searchable-dropdown-container .searchable-dropdown .search-input-container:focus-within {
  border-color: var(--primary-color, #004A9A);
  box-shadow: 0 0 0 3px rgba(0, 74, 154, 0.1);
}
.searchable-dropdown-container .searchable-dropdown .search-input-container:hover {
  border-color: #bbb;
}
.searchable-dropdown-container .searchable-dropdown .search-input-container .search-input {
  flex: 1 1;
  padding: 12px;
  border: none;
  outline: none;
  font-size: 14px;
  background: transparent;
}
.searchable-dropdown-container .searchable-dropdown .search-input-container .search-input::placeholder {
  color: #999;
}
.searchable-dropdown-container .searchable-dropdown .search-input-container .search-input:disabled {
  background: #f5f5f5;
  color: #999;
}
.searchable-dropdown-container .searchable-dropdown .search-input-container .dropdown-toggle-btn {
  padding: 12px 16px;
  border: none;
  border-left: 1px solid #ddd;
  background: #f8f9fa;
  color: #666;
  cursor: pointer;
  transition: all 0.2s ease;
}
.searchable-dropdown-container .searchable-dropdown .search-input-container .dropdown-toggle-btn:hover:not(:disabled) {
  background: #e9ecef;
  color: #333;
}
.searchable-dropdown-container .searchable-dropdown .search-input-container .dropdown-toggle-btn:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}
.searchable-dropdown-container .searchable-dropdown .dropdown-options {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  max-height: 250px;
  overflow-y: auto;
  overflow-x: hidden;
  background: white;
  border: 2px solid #ddd;
  border-top: 1px solid #ddd;
  border-radius: 6px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  z-index: 9999;
  margin-top: 2px;
  /* Custom scrollbar styling */
  /* Fade effect for overflow indication */
  /* Show scroll indicator shadow when scrollable */
}
.searchable-dropdown-container .searchable-dropdown .dropdown-options::-webkit-scrollbar {
  width: 8px;
}
.searchable-dropdown-container .searchable-dropdown .dropdown-options::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 0 4px 4px 0;
}
.searchable-dropdown-container .searchable-dropdown .dropdown-options::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}
.searchable-dropdown-container .searchable-dropdown .dropdown-options::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
.searchable-dropdown-container .searchable-dropdown .dropdown-options::after {
  content: "";
  position: sticky;
  bottom: 0;
  height: 10px;
  background: linear-gradient(transparent, rgba(255, 255, 255, 0.8));
  pointer-events: none;
  display: block;
}
.searchable-dropdown-container .searchable-dropdown .dropdown-options.has-scroll {
  border-bottom: 3px solid #e0e0e0;
}
.searchable-dropdown-container .searchable-dropdown .dropdown-options.has-scroll::before {
  content: "";
  position: sticky;
  top: 0;
  height: 5px;
  background: linear-gradient(rgba(255, 255, 255, 0.8), transparent);
  pointer-events: none;
  display: block;
  z-index: 1;
}
.searchable-dropdown-container .searchable-dropdown .dropdown-options .dropdown-option {
  padding: 16px;
  cursor: pointer;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  transition: all 0.2s ease;
  background: white;
  min-height: 60px;
  flex-shrink: 0;
}
.searchable-dropdown-container .searchable-dropdown .dropdown-options .dropdown-option:first-child {
  border-radius: 6px 6px 0 0;
}
.searchable-dropdown-container .searchable-dropdown .dropdown-options .dropdown-option:last-child {
  border-bottom: none;
  border-radius: 0 0 6px 6px;
}
.searchable-dropdown-container .searchable-dropdown .dropdown-options .dropdown-option:hover:not(.loading-option):not(.no-results-option) {
  background: #f8f9ff;
  border-left: 3px solid var(--primary-color, #004A9A);
}
.searchable-dropdown-container .searchable-dropdown .dropdown-options .dropdown-option.selected {
  background: #e3f2fd;
  color: #1976d2;
  border-left: 3px solid #1976d2;
}
.searchable-dropdown-container .searchable-dropdown .dropdown-options .dropdown-option.loading-option, .searchable-dropdown-container .searchable-dropdown .dropdown-options .dropdown-option.no-results-option {
  color: #999;
  cursor: default;
  font-style: italic;
  justify-content: center;
  background: #f9f9f9;
}
.searchable-dropdown-container .searchable-dropdown .dropdown-options .dropdown-option .option-content {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1 1;
}
.searchable-dropdown-container .searchable-dropdown .dropdown-options .dropdown-option .option-content .option-name {
  font-weight: 500;
  color: #333;
}
.searchable-dropdown-container .searchable-dropdown .dropdown-options .dropdown-option .option-content .option-description {
  font-size: 0.875rem;
  color: #666;
}
.searchable-dropdown-container .searchable-dropdown .dropdown-options .dropdown-option .selected-indicator {
  color: #4caf50;
  font-weight: bold;
  font-size: 16px;
}

.label-selection-actions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 20px;
  padding-top: 15px;
  border-top: 1px solid #e0e0e0;
}

.btn-cancel {
  padding: 8px 16px;
  background: #f5f5f5;
  color: #666;
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.2s ease;
}
.btn-cancel:hover {
  background: #e5e5e5;
  border-color: #bbb;
}

.btn-primary {
  padding: 8px 16px;
  background: var(--primary-color);
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.2s ease;
}
.btn-primary:hover:not(:disabled) {
  background: #005a9a;
}
.btn-primary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.label-form-modal-wrapper {
  background: white;
  border-radius: 8px;
  max-width: 900px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
}
.label-form-modal-wrapper .label-form-container {
  background: transparent;
  box-shadow: none;
  max-width: 100%;
  padding: 0;
}
.label-form-modal-wrapper .label-form-card {
  box-shadow: none;
  max-width: 100%;
}

.remove-labels-section {
  margin-top: 20px;
  padding: 16px;
  background-color: #f9fafb;
  border-radius: 8px;
}
.remove-labels-section .assigned-labels-title {
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 12px;
}
.remove-labels-section .loading-message,
.remove-labels-section .no-labels-message {
  text-align: center;
  padding: 20px;
  color: #6b7280;
  font-size: 14px;
}
.remove-labels-section .assigned-labels-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 12px;
}
.remove-labels-section .assigned-label-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 16px;
  font-size: 13px;
  font-weight: 500;
  border: 2px solid transparent;
  cursor: pointer;
  transition: all 0.2s ease;
}
.remove-labels-section .assigned-label-pill:hover {
  transform: scale(1.05);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.remove-labels-section .assigned-label-pill.selected-for-removal {
  border-color: #dc2626;
  cursor: pointer;
}
.remove-labels-section .assigned-label-pill .label-pill-name {
  flex: 1 1;
}
.remove-labels-section .assigned-label-pill .remove-indicator {
  font-size: 18px;
  font-weight: bold;
  color: #dc2626;
}
.remove-labels-section .removal-hint {
  margin-top: 12px;
  padding: 8px 12px;
  background-color: #fef3c7;
  border-left: 3px solid #f59e0b;
  border-radius: 4px;
  font-size: 13px;
  color: #92400e;
}

.btn-danger {
  padding: 10px 20px;
  background-color: #dc2626;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}
.btn-danger:hover:not(:disabled) {
  background-color: #b91c1c;
}
.btn-danger:disabled {
  background-color: #d1d5db;
  cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./src/components/LabelSelectionModal/LabelSelectionModal.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,oCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AACF;;AAEA;EACE,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,0CAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;AACF;AACE;EACE,WAAA;EACA,YAAA;EACA,2CAAA;EACA,iBAAA;AACJ;;AAGA;EACE,eAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;AAAF;;AAGA;EACE,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;AAAF;;AAGA;EACE,WAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,uBAAA;EACA,eAAA;AAAF;AAEE;EACE,aAAA;EACA,2CAAA;EACA,2CAAA;AAAJ;AAGE;EACE,yBAAA;EACA,mBAAA;EACA,YAAA;AADJ;AAIE;EACE,YAAA;AAFJ;;AAMA;EACE,WAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;AAHF;AAKE;EACE,aAAA;EACA,2CAAA;EACA,2CAAA;AAHJ;;AAOA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,kBAAA;AAJF;;AAOA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAJF;;AAOA;EACE,aAAA;EACA,uBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;AAJF;AAME;EACE,2CAAA;EACA,yBAAA;AAJJ;AAOE;EACE,kBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,2CAAA;AALJ;;AASA;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AANF;;AASA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AANF;;AASA;EACE,gBAAA;EACA,WAAA;EACA,eAAA;AANF;;AASA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oCAAA;AANF;;AASA;EACE,eAAA;EACA,WAAA;EACA,gBAAA;AANF;;AASA;EACE,eAAA;EACA,WAAA;EACA,gBAAA;AANF;;AASA;EACE,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;AANF;;AASA;EACE,gBAAA;EACA,kBAAA;EACA,mFAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,2CAAA;AANF;;AASA;EACE,gBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;AANF;;AASA;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AANF;;AASA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AANF;;AASA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,uBAAA;EACA,yCAAA;EACA,yBAAA;AANF;AAQE;EACE,qBAAA;EACA,wCAAA;AANJ;AASE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,SAAA;AAPJ;AASI;EACE,gBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAPN;AAUI;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AARN;;AAaA;EACE,gBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,cAAA;AAVF;AAYE;EAEE,sBAAA;AAXJ;AAcE;EACE,sBAAA;AAZJ;;AAgBA,+BAAA;AACA;EACE,mBAAA;EACA,kBAAA;AAbF;AAeE;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;AAbJ;AAgBE;EACE,kBAAA;EAEA,yBAAA;AAfJ;AAgBI;EACE,uBAAA;AAdN;AAiBI;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAfN;AAiBM;EACE,2CAAA;EACA,2CAAA;AAfR;AAkBM;EACE,kBAAA;AAhBR;AAmBM;EACE,SAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;AAjBR;AAmBQ;EACE,WAAA;AAjBV;AAoBQ;EACE,mBAAA;EACA,WAAA;AAlBV;AAsBM;EACE,kBAAA;EACA,YAAA;EACA,2BAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,yBAAA;AApBR;AAsBQ;EACE,mBAAA;EACA,WAAA;AApBV;AAuBQ;EACE,mBAAA;EACA,YAAA;AArBV;AA0BI;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,0BAAA;EACA,kBAAA;EACA,0CAAA;EACA,aAAA;EACA,eAAA;EAEA,6BAAA;EAmBA,wCAAA;EAWA,iDAAA;AArDN;AAwBM;EACE,UAAA;AAtBR;AAyBM;EACE,mBAAA;EACA,0BAAA;AAvBR;AA0BM;EACE,mBAAA;EACA,kBAAA;AAxBR;AA0BQ;EACE,mBAAA;AAxBV;AA6BM;EACE,WAAA;EACA,gBAAA;EACA,SAAA;EACA,YAAA;EACA,kEAAA;EACA,oBAAA;EACA,cAAA;AA3BR;AA+BM;EACE,gCAAA;AA7BR;AA+BQ;EACE,WAAA;EACA,gBAAA;EACA,MAAA;EACA,WAAA;EACA,kEAAA;EACA,oBAAA;EACA,cAAA;EACA,UAAA;AA7BV;AAiCM;EACE,aAAA;EACA,eAAA;EACA,gCAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,yBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AA/BR;AAkCQ;EACE,0BAAA;AAhCV;AAmCQ;EACE,mBAAA;EACA,0BAAA;AAjCV;AAoCQ;EACE,mBAAA;EACA,oDAAA;AAlCV;AAqCQ;EACE,mBAAA;EACA,cAAA;EACA,8BAAA;AAnCV;AAsCQ;EAEE,WAAA;EACA,eAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;AArCV;AAwCQ;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,SAAA;AAtCV;AAwCU;EACE,gBAAA;EACA,WAAA;AAtCZ;AAyCU;EACE,mBAAA;EACA,WAAA;AAvCZ;AA2CQ;EACE,cAAA;EACA,iBAAA;EACA,eAAA;AAzCV;;AAgDA;EACE,aAAA;EACA,SAAA;EACA,yBAAA;EACA,gBAAA;EACA,iBAAA;EACA,6BAAA;AA7CF;;AAgDA;EACE,iBAAA;EACA,mBAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AA7CF;AA+CE;EACE,mBAAA;EACA,kBAAA;AA7CJ;;AAiDA;EACE,iBAAA;EACA,gCAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AA9CF;AAgDE;EACE,mBAAA;AA9CJ;AAiDE;EACE,YAAA;EACA,mBAAA;AA/CJ;;AAmDA;EACE,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,0CAAA;AAhDF;AAmDE;EACE,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,UAAA;AAjDJ;AAoDE;EACE,gBAAA;EACA,eAAA;AAlDJ;;AAwDA;EACE,gBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;AArDF;AAuDE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AArDJ;AAwDE;;EAEE,kBAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;AAtDJ;AAyDE;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,mBAAA;AAvDJ;AA0DE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,6BAAA;EACA,eAAA;EACA,yBAAA;AAxDJ;AA0DI;EACE,sBAAA;EACA,wCAAA;AAxDN;AA2DI;EACE,qBAAA;EACA,eAAA;AAzDN;AA4DI;EACE,SAAA;AA1DN;AA6DI;EACE,eAAA;EACA,iBAAA;EACA,cAAA;AA3DN;AA+DE;EACE,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,8BAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;AA7DJ;;AAiEA;EACE,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AA9DF;AAgEE;EACE,yBAAA;AA9DJ;AAiEE;EACE,yBAAA;EACA,mBAAA;AA/DJ","sourcesContent":[".label-selection-modal-backdrop {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background-color: rgba(0, 0, 0, 0.5);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 9998;\r\n}\r\n\r\n.label-selection-modal {\r\n  background: white;\r\n  border-radius: 8px;\r\n  padding: 24px;\r\n  width: 90%;\r\n  max-width: 500px;\r\n  max-height: 90vh;\r\n  overflow-y: auto;\r\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.label-selection-modal-title {\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n  margin-bottom: 16px;\r\n  text-align: center;\r\n  color: #333;\r\n}\r\n\r\n.label-selection-options {\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.label-selection-option {\r\n  display: flex;\r\n  align-items: center;\r\n  cursor: pointer;\r\n  font-weight: 500;\r\n  color: #333;\r\n  margin-bottom: 8px;\r\n\r\n  input {\r\n    width: 16px;\r\n    height: 16px;\r\n    accent-color: var(--primary-color, #004A9A);\r\n    margin-right: 8px;\r\n  }\r\n}\r\n\r\n.label-selection-desc {\r\n  font-size: 14px;\r\n  color: #666;\r\n  margin-left: 24px;\r\n  line-height: 1.4;\r\n  margin-top: 8px;\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.existing-labels-section {\r\n  margin-top: 20px;\r\n  margin-bottom: 20px;\r\n  padding: 15px;\r\n  border: 1px solid #e2e8f0;\r\n  border-radius: 8px;\r\n  background-color: #f8f9fa;\r\n  position: relative;\r\n}\r\n\r\n.search-container {\r\n  margin-bottom: 15px;\r\n}\r\n\r\n.dropdown-container {\r\n  margin-bottom: 15px;\r\n}\r\n\r\n.dropdown-label {\r\n  display: block;\r\n  margin-bottom: 8px;\r\n  font-weight: 500;\r\n  color: #333;\r\n  font-size: 14px;\r\n}\r\n\r\n.label-dropdown {\r\n  width: 100%;\r\n  padding: 8px 12px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 4px;\r\n  font-size: 14px;\r\n  background-color: white;\r\n  cursor: pointer;\r\n  \r\n  &:focus {\r\n    outline: none;\r\n    border-color: var(--primary-color, #004A9A);\r\n    box-shadow: 0 0 0 2px rgba(0, 74, 154, 0.2);\r\n  }\r\n\r\n  &:disabled {\r\n    background-color: #f5f5f5;\r\n    cursor: not-allowed;\r\n    opacity: 0.6;\r\n  }\r\n\r\n  option {\r\n    padding: 8px;\r\n  }\r\n}\r\n\r\n.label-search-input {\r\n  width: 100%;\r\n  padding: 8px 12px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 4px;\r\n  font-size: 14px;\r\n  \r\n  &:focus {\r\n    outline: none;\r\n    border-color: var(--primary-color, #004A9A);\r\n    box-shadow: 0 0 0 2px rgba(0, 74, 154, 0.2);\r\n  }\r\n}\r\n\r\n.loading-container {\r\n  text-align: center;\r\n  padding: 20px;\r\n  color: #666;\r\n  font-style: italic;\r\n}\r\n\r\n.labels-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n}\r\n\r\n.label-item {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  padding: 10px;\r\n  border: 1px solid #e0e0e0;\r\n  border-radius: 6px;\r\n  background: white;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n  \r\n  &:hover {\r\n    border-color: var(--primary-color, #004A9A);\r\n    background-color: #f8f9ff;\r\n  }\r\n\r\n  input[type=\"checkbox\"] {\r\n    margin-right: 12px;\r\n    margin-top: 2px;\r\n    width: 16px;\r\n    height: 16px;\r\n    accent-color: var(--primary-color, #004A9A);\r\n  }\r\n}\r\n\r\n.label-info {\r\n  flex: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 4px;\r\n}\r\n\r\n.label-name-color {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.label-name {\r\n  font-weight: 500;\r\n  color: #333;\r\n  font-size: 14px;\r\n}\r\n\r\n.label-color-indicator {\r\n  width: 16px;\r\n  height: 16px;\r\n  border-radius: 3px;\r\n  border: 1px solid rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.label-description {\r\n  font-size: 12px;\r\n  color: #666;\r\n  line-height: 1.3;\r\n}\r\n\r\n.label-priority {\r\n  font-size: 11px;\r\n  color: #888;\r\n  font-weight: 500;\r\n}\r\n\r\n.no-labels-message {\r\n  text-align: center;\r\n  color: #666;\r\n  font-style: italic;\r\n  padding: 20px;\r\n}\r\n\r\n.selected-count {\r\n  margin-top: 15px;\r\n  padding: 10px 15px;\r\n  background: linear-gradient(135deg, var(--primary-color, #004A9A) 0%, #0066cc 100%);\r\n  color: white;\r\n  border-radius: 6px;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  text-align: center;\r\n  box-shadow: 0 2px 4px rgba(0, 74, 154, 0.2);\r\n}\r\n\r\n.selected-labels-container {\r\n  margin-top: 20px;\r\n  padding: 15px;\r\n  border: 1px solid #e2e8f0;\r\n  border-radius: 6px;\r\n  background-color: #f8fafc;\r\n}\r\n\r\n.selected-labels-title {\r\n  margin: 0 0 12px 0;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  color: #374151;\r\n}\r\n\r\n.selected-labels-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n}\r\n\r\n.selected-label-item {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 10px 12px;\r\n  border: 1px solid #d1d5db;\r\n  border-radius: 6px;\r\n  background-color: white;\r\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\r\n  transition: all 0.2s ease;\r\n\r\n  &:hover {\r\n    border-color: #9ca3af;\r\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n  }\r\n\r\n  .label-info {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 4px;\r\n    flex: 1;\r\n\r\n    .label-name {\r\n      font-weight: 500;\r\n      color: #111827;\r\n      font-size: 14px;\r\n      line-height: 1.4;\r\n    }\r\n\r\n    .label-description {\r\n      font-size: 12px;\r\n      color: #6b7280;\r\n      line-height: 1.3;\r\n      font-style: italic;\r\n    }\r\n  }\r\n}\r\n\r\n.remove-label-btn {\r\n  background: grey;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 50%;\r\n  width: 22px;\r\n  height: 22px;\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n  font-weight: bold;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: all 0.2s ease;\r\n  flex-shrink: 0;\r\n\r\n  &:hover {\r\n    //background: #dc2626;\r\n    transform: scale(1.05);\r\n  }\r\n\r\n  &:active {\r\n    transform: scale(0.95);\r\n  }\r\n}\r\n\r\n/* Searchable Dropdown Styles */\r\n.searchable-dropdown-container {\r\n  margin-bottom: 20px;\r\n  position: relative;\r\n  \r\n  .dropdown-label {\r\n    display: block;\r\n    margin-bottom: 8px;\r\n    font-weight: 500;\r\n    color: #333;\r\n  }\r\n  \r\n  .searchable-dropdown {\r\n    position: relative;\r\n    \r\n    /* Add smooth scrolling */\r\n    * {\r\n      scroll-behavior: smooth;\r\n    }\r\n    \r\n    .search-input-container {\r\n      display: flex;\r\n      border: 2px solid #ddd;\r\n      border-radius: 6px;\r\n      overflow: hidden;\r\n      background: white;\r\n      \r\n      &:focus-within {\r\n        border-color: var(--primary-color, #004A9A);\r\n        box-shadow: 0 0 0 3px rgba(0, 74, 154, 0.1);\r\n      }\r\n      \r\n      &:hover {\r\n        border-color: #bbb;\r\n      }\r\n      \r\n      .search-input {\r\n        flex: 1;\r\n        padding: 12px;\r\n        border: none;\r\n        outline: none;\r\n        font-size: 14px;\r\n        background: transparent;\r\n        \r\n        &::placeholder {\r\n          color: #999;\r\n        }\r\n        \r\n        &:disabled {\r\n          background: #f5f5f5;\r\n          color: #999;\r\n        }\r\n      }\r\n      \r\n      .dropdown-toggle-btn {\r\n        padding: 12px 16px;\r\n        border: none;\r\n        border-left: 1px solid #ddd;\r\n        background: #f8f9fa;\r\n        color: #666;\r\n        cursor: pointer;\r\n        transition: all 0.2s ease;\r\n        \r\n        &:hover:not(:disabled) {\r\n          background: #e9ecef;\r\n          color: #333;\r\n        }\r\n        \r\n        &:disabled {\r\n          cursor: not-allowed;\r\n          opacity: 0.5;\r\n        }\r\n      }\r\n    }\r\n    \r\n    .dropdown-options {\r\n      position: absolute;\r\n      top: 100%;\r\n      left: 0;\r\n      right: 0;\r\n      max-height: 250px;\r\n      overflow-y: auto;\r\n      overflow-x: hidden;\r\n      background: white;\r\n      border: 2px solid #ddd;\r\n      border-top: 1px solid #ddd;\r\n      border-radius: 6px;\r\n      box-shadow: 0 8px 24px rgba(0,0,0,0.15);\r\n      z-index: 9999;\r\n      margin-top: 2px;\r\n      \r\n      /* Custom scrollbar styling */\r\n      &::-webkit-scrollbar {\r\n        width: 8px;\r\n      }\r\n      \r\n      &::-webkit-scrollbar-track {\r\n        background: #f1f1f1;\r\n        border-radius: 0 4px 4px 0;\r\n      }\r\n      \r\n      &::-webkit-scrollbar-thumb {\r\n        background: #c1c1c1;\r\n        border-radius: 4px;\r\n        \r\n        &:hover {\r\n          background: #a8a8a8;\r\n        }\r\n      }\r\n      \r\n      /* Fade effect for overflow indication */\r\n      &::after {\r\n        content: '';\r\n        position: sticky;\r\n        bottom: 0;\r\n        height: 10px;\r\n        background: linear-gradient(transparent, rgba(255,255,255,0.8));\r\n        pointer-events: none;\r\n        display: block;\r\n      }\r\n      \r\n      /* Show scroll indicator shadow when scrollable */\r\n      &.has-scroll {\r\n        border-bottom: 3px solid #e0e0e0;\r\n        \r\n        &::before {\r\n          content: '';\r\n          position: sticky;\r\n          top: 0;\r\n          height: 5px;\r\n          background: linear-gradient(rgba(255,255,255,0.8), transparent);\r\n          pointer-events: none;\r\n          display: block;\r\n          z-index: 1;\r\n        }\r\n      }\r\n      \r\n      .dropdown-option {\r\n        padding: 16px;\r\n        cursor: pointer;\r\n        border-bottom: 1px solid #f0f0f0;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: space-between;\r\n        transition: all 0.2s ease;\r\n        background: white;\r\n        min-height: 60px;\r\n        flex-shrink: 0;\r\n        \r\n        \r\n        &:first-child {\r\n          border-radius: 6px 6px 0 0;\r\n        }\r\n        \r\n        &:last-child {\r\n          border-bottom: none;\r\n          border-radius: 0 0 6px 6px;\r\n        }\r\n        \r\n        &:hover:not(.loading-option):not(.no-results-option) {\r\n          background: #f8f9ff;\r\n          border-left: 3px solid var(--primary-color, #004A9A);\r\n        }\r\n        \r\n        &.selected {\r\n          background: #e3f2fd;\r\n          color: #1976d2;\r\n          border-left: 3px solid #1976d2;\r\n        }\r\n        \r\n        &.loading-option,\r\n        &.no-results-option {\r\n          color: #999;\r\n          cursor: default;\r\n          font-style: italic;\r\n          justify-content: center;\r\n          background: #f9f9f9;\r\n        }\r\n        \r\n        .option-content {\r\n          display: flex;\r\n          flex-direction: column;\r\n          gap: 4px;\r\n          flex: 1;\r\n          \r\n          .option-name {\r\n            font-weight: 500;\r\n            color: #333;\r\n          }\r\n          \r\n          .option-description {\r\n            font-size: 0.875rem;\r\n            color: #666;\r\n          }\r\n        }\r\n        \r\n        .selected-indicator {\r\n          color: #4caf50;\r\n          font-weight: bold;\r\n          font-size: 16px;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.label-selection-actions {\r\n  display: flex;\r\n  gap: 12px;\r\n  justify-content: flex-end;\r\n  margin-top: 20px;\r\n  padding-top: 15px;\r\n  border-top: 1px solid #e0e0e0;\r\n}\r\n\r\n.btn-cancel {\r\n  padding: 8px 16px;\r\n  background: #f5f5f5;\r\n  color: #666;\r\n  border: 1px solid #ddd;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  font-weight: 500;\r\n  transition: all 0.2s ease;\r\n\r\n  &:hover {\r\n    background: #e5e5e5;\r\n    border-color: #bbb;\r\n  }\r\n}\r\n\r\n.btn-primary {\r\n  padding: 8px 16px;\r\n  background: var(--primary-color);\r\n  color: white;\r\n  border: none;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  font-weight: 500;\r\n  transition: all 0.2s ease;\r\n\r\n  &:hover:not(:disabled) {\r\n    background:  #005a9a;\r\n  }\r\n\r\n  &:disabled {\r\n    opacity: 0.6;\r\n    cursor: not-allowed;\r\n  }\r\n}\r\n// Add this at the end of the file\r\n.label-form-modal-wrapper {\r\n  background: white;\r\n  border-radius: 8px;\r\n  max-width: 900px;\r\n  width: 90%;\r\n  max-height: 90vh;\r\n  overflow-y: auto;\r\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);\r\n  \r\n  // Ensure the form inside doesn't have its own container styling\r\n  .label-form-container {\r\n    background: transparent;\r\n    box-shadow: none;\r\n    max-width: 100%;\r\n    padding: 0;\r\n  }\r\n  \r\n  .label-form-card {\r\n    box-shadow: none;\r\n    max-width: 100%;\r\n  }\r\n}\r\n\r\n// Add these new styles to your existing SCSS file\r\n\r\n.remove-labels-section {\r\n  margin-top: 20px;\r\n  padding: 16px;\r\n  background-color: #f9fafb;\r\n  border-radius: 8px;\r\n\r\n  .assigned-labels-title {\r\n    font-size: 14px;\r\n    font-weight: 600;\r\n    color: #374151;\r\n    margin-bottom: 12px;\r\n  }\r\n\r\n  .loading-message,\r\n  .no-labels-message {\r\n    text-align: center;\r\n    padding: 20px;\r\n    color: #6b7280;\r\n    font-size: 14px;\r\n  }\r\n\r\n  .assigned-labels-grid {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    gap: 8px;\r\n    margin-bottom: 12px;\r\n  }\r\n\r\n  .assigned-label-pill {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    gap: 6px;\r\n    padding: 6px 12px;\r\n    border-radius: 16px;\r\n    font-size: 13px;\r\n    font-weight: 500;\r\n    border: 2px solid transparent;\r\n    cursor: pointer;\r\n    transition: all 0.2s ease;\r\n\r\n    &:hover {\r\n      transform: scale(1.05);\r\n      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n    }\r\n\r\n    &.selected-for-removal {\r\n      border-color: #dc2626;\r\n      cursor: pointer;\r\n    }\r\n\r\n    .label-pill-name {\r\n      flex: 1;\r\n    }\r\n\r\n    .remove-indicator {\r\n      font-size: 18px;\r\n      font-weight: bold;\r\n      color: #dc2626;\r\n    }\r\n  }\r\n\r\n  .removal-hint {\r\n    margin-top: 12px;\r\n    padding: 8px 12px;\r\n    background-color: #fef3c7;\r\n    border-left: 3px solid #f59e0b;\r\n    border-radius: 4px;\r\n    font-size: 13px;\r\n    color: #92400e;\r\n  }\r\n}\r\n\r\n.btn-danger {\r\n  padding: 10px 20px;\r\n  background-color: #dc2626;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 6px;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n\r\n  &:hover:not(:disabled) {\r\n    background-color: #b91c1c;\r\n  }\r\n\r\n  &:disabled {\r\n    background-color: #d1d5db;\r\n    cursor: not-allowed;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
